import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

const LABELS = {
  feed: 'Feed',
  funcionario: 'Funcionários',
  veiculo: 'Veículos',
  relatorio: 'Relatórios',
  mercadoria: 'Mercadorias',
  almoxarifado: 'Almoxarifado',
  epi: 'EPI',
  romaneio: 'Romaneio',
  fluxoCaixa: 'Fluxo de Caixa',
  setor: 'Setor',
  sc: 'Solicitações de Compra',
  propostacomercial: 'Proposta Comercial',
  medicao: 'Medição',
  os: 'Ordem de Serviço',
  cadastro: 'Cadastro',
  editar: 'Editar',
  atualizacao: 'Atualização',
  entrada: 'Entrada',
  saida: 'Saída',
  abastecimento: 'Abastecimento',
  trocaoleo: 'Troca de Óleo',
  manutencao: 'Manutenção',
  orcamento: 'Orçamento',
  aprovados: 'Aprovados',
  custoFixo: 'Custo Fixo',
  custoVariavel: 'Custo Variável',
};

const isIdSegment = (segment) => /^[0-9a-fA-F-]+$/.test(segment) && /\d/.test(segment);

const formatSegment = (segment) => LABELS[segment] || segment.charAt(0).toUpperCase() + segment.slice(1);

function RouteBreadcrumbs() {
  const location = useLocation();
  const navigate = useNavigate();

  const segments = location.pathname.split('/').filter(Boolean);

  if (segments.length === 0 || location.pathname === '/feed') {
    return null;
  }

  let cumulativePath = '';
  const crumbs = [];
  segments.forEach((segment) => {
    cumulativePath += `/${segment}`;
    if (isIdSegment(segment)) return;
    crumbs.push({ label: formatSegment(segment), to: cumulativePath });
  });

  if (crumbs.length === 0) {
    return null;
  }

  const parentPath = segments.length > 1 ? `/${segments.slice(0, -1).join('/')}` : '/feed';

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        px: { xs: 2, sm: 3, md: 4 },
        py: 1.25,
        borderBottom: '1px solid',
        borderColor: 'divider',
        backgroundColor: 'background.paper',
      }}
    >
      <Tooltip title="Voltar">
        <IconButton size="small" onClick={() => navigate(parentPath)} aria-label="Voltar">
          <ArrowBackIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} sx={{ fontSize: 14 }}>
        <Link
          component={RouterLink}
          to="/feed"
          underline="hover"
          color="inherit"
          sx={{ display: 'flex', alignItems: 'center', fontSize: 14 }}
        >
          <HomeOutlinedIcon fontSize="inherit" sx={{ mr: 0.5 }} />
          Início
        </Link>
        {crumbs.map((crumb, index) => {
          const isLast = index === crumbs.length - 1;
          return isLast ? (
            <Typography key={crumb.to} color="text.primary" sx={{ fontSize: 14, fontWeight: 600 }}>
              {crumb.label}
            </Typography>
          ) : (
            <Link key={crumb.to} component={RouterLink} to={crumb.to} underline="hover" color="inherit" sx={{ fontSize: 14 }}>
              {crumb.label}
            </Link>
          );
        })}
      </Breadcrumbs>
    </Box>
  );
}

export default RouteBreadcrumbs;
